import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HomeComponent } from './components/home/home.component';
import { BannerComponent } from './components/banner/banner.component';
import { UpcomingTrainingComponent } from './components/upcoming-training/upcoming-training.component';
import { AboutComponent } from './components/about/about.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ArticleCardComponent } from './components/article-card/article-card.component';
import { FacebookBannerComponent } from './components/facebook-banner/facebook-banner.component';
import { MediaCardComponent } from './components/media-card/media-card.component';
import {CardFormComponent} from './components/card-form/card-form.component';
import {SiteHeaderComponent} from './components/site-header/site-header.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SiteFooterComponent } from './components/site-footer/site-footer.component';
import { EventsComponent } from './components/app-events/app-events.component';
import { EventDetailComponent } from './components/app-event-page/app-event-detail.component';
import { ToastComponent } from './components/toast/toast.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ShopComponent } from './components/app-shop/app-shop.component';
import { ProductDetailComponent } from './components/app-product-detail/app-product-detail.component';
import { CartComponent } from './components/app-cart/app-cart.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CheckoutComponent } from './components/app-checkout/app-checkout.component';
import { ConfirmationComponent } from './components/app-confirmation/app-confirmation.component';
import { UnauthorizedComponent } from './components/app-unauthorized/app-unauthorized.component';

@NgModule({
	declarations: [
		HomeComponent,
		BannerComponent,
		UpcomingTrainingComponent,
		AboutComponent,
		ContactUsComponent,
		ArticleCardComponent,
		FacebookBannerComponent,
		MediaCardComponent,
		SiteHeaderComponent,
    	CardFormComponent,
		SiteFooterComponent,
		EventsComponent,
		EventDetailComponent,
		ToastComponent,
		LoginComponent,
		RegisterComponent,
		ShopComponent,
		ProductDetailComponent,
		CartComponent,
		CheckoutComponent,
		ConfirmationComponent,
		UnauthorizedComponent
	],
  imports: [
    RouterModule,
    NgbModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
	NgxSpinnerModule,
	FontAwesomeModule
  ],
	exports: [
		HomeComponent,
		BannerComponent,
		UpcomingTrainingComponent,
		AboutComponent,
		ContactUsComponent,
		ArticleCardComponent,
		FacebookBannerComponent,
		MediaCardComponent,
    	CardFormComponent,
		SiteHeaderComponent,
		SiteFooterComponent,
		EventsComponent,
		EventDetailComponent,
		ToastComponent,
		LoginComponent,
		RegisterComponent,
		ShopComponent,
		ProductDetailComponent,
		CartComponent,
		CheckoutComponent,
		ConfirmationComponent,
		UnauthorizedComponent
	]
})
export class SharedModule {}
